import { useLayoutEffect, useRef } from "react";

const getChildren = (el) => {
  const siblings = [];
  let sibling = el.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== el) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }

  return siblings;
};

export default function useMaxHeight(stage) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const children = getChildren(ref.current);
    const thisChild = children[stage];
    if (!thisChild) return;
    thisChild.style.maxHeight = "1000px";
    thisChild.style.opacity = 1;
    const height = `${thisChild.scrollHeight}px`;
    children.forEach((el) => {
      if (el === thisChild) {
        el.style.maxHeight = "1000px";
        el.style.overflow = "initial";
        el.style.opacity = 1;
      } else {
        el.style.maxHeight = height;
        el.style.overflow = "hidden";
        el.style.opacity = 0;
      }
    });

    // return () => {
    //   console.log('useLayoutEffect return function called', thisChild)
    //   setTimeout(() => {
    //   children.forEach(el => {
    //     if (el === thisChild) {
    //       el.style.maxHeight = '0px'
    //       el.style.opacity = 0
    //       el.style.overflow = 'hidden'
    //     }
    //   })
    // }, 300)
    // }
  }, [ref, stage]);

  return ref;
}
